// One colour per facility, in the order the comparison names them. Shared by
// every section of the report, so a facility is the same colour wherever it
// appears.
export const FACILITY_COLORS = ['#8080ff', '#ff6833']

export const facilityColor = (index: number) =>
  FACILITY_COLORS[index % FACILITY_COLORS.length]
